import fetchApi from "../util/fetchApi";
import checkErrors from './checkErrors';


export const SettingsManagementApi = {
    async setSLASetting(data) {
        return checkErrors(await fetchApi.api.post('manage/settings/sla', { data }));
    },
    async setAlarms(data) {
        return checkErrors(await fetchApi.api.post('manage/settings/alarms', { data }));
    },
    async getUcsContactAgentSyncLog({ take = 50 } = {}) {
        return checkErrors(await fetchApi.api.get('manage/settings/ucs-contact-agent-sync-log', { query: { take } }));
    },
    async runUcsContactAgentSync() {
        return checkErrors(await fetchApi.api.post('manage/settings/ucs-contact-agent-sync'));
    },

}


export default SettingsManagementApi;
